import { IsOptional } from 'class-validator';
import { IsMongoIdObject } from '../../decorators/is-mongo-object-id.decorator';
import { PropertyId, UserId } from '../../types';

export class FileContextDto {
  @IsMongoIdObject()
  @IsOptional()
  user?: UserId;

  @IsMongoIdObject()
  @IsOptional()
  property?: PropertyId;
}
